<template>
  <v-card
    class="pr-2 d-flex flex-column justify-center "
    :class="isOpenModalAjoutRedirection ? 'cursor-no-drop' : ''"
    @click="onAjouteRedirection"
  >
    <div class="align-self-center py-1">
      <v-icon
        color="secondary"
        x-large
      >
        mdi-plus
      </v-icon>
    </div>
    <div class="align-self-center py-1">
      <v-card-title
        class="secondary--text text-h6 text-md-subtitle-1 font-weight-bold align-self-center"
      >
        Ajouter un rebond
      </v-card-title>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'AjoutRebond',
  props: {
    isOpenModalAjoutRedirection : {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onAjouteRedirection () {
      this.$emit('ajout-redirection')
    }
  }
}
</script>

<style lang="scss" scoped>
.cursor-no-drop {
  cursor: no-drop;
}
</style>
